var Heco = typeof Heco === "object" ? Heco : {}; Heco["app"] =
 (function(modules) { 
 	var installedModules = {};
 	function __webpack_require__(moduleId) {
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
 		module.l = true;
 		return module.exports;
 	}
 	__webpack_require__.m = modules;
 	__webpack_require__.c = installedModules;
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
 	__webpack_require__.p = "";
 	return __webpack_require__(__webpack_require__.s = 0);
 })
 ([
 (function(module, exports) {

var swiper = new Swiper('.swiper-container', {
  loop: window.slides > 1,
  allowTouchMove: false,
  autoplay: {
    delay: 10000,
    disableOnInteraction: true
  },
  pagination: {
    el: '.swiper-pagination'
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  }
});
var swiper = new Swiper('.swiper-about', {
  loop: window.slides > 1,
  allowTouchMove: false,
  centerInsufficientSlides: true
});
var swiperProducts = new Swiper('.swiper-products', {
  slidesPerView: 1,
  spaceBetween: 0,
  centerInsufficientSlides: true,
  watchOverflow: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  },
  breakpoints: {
    1475: {
      slidesPerView: 5,
      loop: window.productSlides > 5
    },
    1200: {
      slidesPerView: 4,
      loop: window.productSlides > 4
    },
    768: {
      slidesPerView: 3,
      loop: window.productSlides > 3
    },
    515: {
      slidesPerView: 2,
      loop: window.productSlides > 2
    }
  }
});
window.adjustSlider = function (index) {
  var clicked = document.getElementById("vert-".concat(index));
  var slides = document.getElementsByClassName('gallery-img');
  Array.from(slides).forEach(function (element) {
    element.classList.remove('active');
  });
  clicked.classList.add('active');
  window.swiperProd.slideTo(index, 500, true);
};
window.swiperProd = new Swiper('.swiper-product-images', {
  slidesPerView: 1,
  spaceBetween: 2,
  loop: false,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  }
});
var swiper = new Swiper('.swiper-reviews', {
  slidesPerView: 1,
  spaceBetween: 50,
  centerInsufficientSlides: true,
  loop: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  },
  breakpoints: {
    1200: {
      slidesPerView: 4,
      loop: window.reviewSlides > 4
    },
    768: {
      slidesPerView: 3,
      loop: window.reviewSlides > 3
    },
    515: {
      slidesPerView: 2,
      loop: window.reviewSlides > 2
    }
  }
});

window.selectSwatch = function (e, finish) {
  var slides = document.querySelectorAll(".".concat(finish, ":not(.finish-icon)"));
  var slide = slides[0];
  swiperProd.slideTo(slide.dataset.index, 500, true);
  var buttons = document.getElementsByClassName('finish-option');
  [].forEach.call(buttons, function (el) {
    el.classList.remove('selected');
  });
  e.classList.add('selected');

  var parentBlock = e.closest('.product-details');
  var targetAtcWrapper = parentBlock.querySelector(".atc-wrapper[data-finish=\"".concat(finish, "\"]"));
  var allAtcWrappers = parentBlock.getElementsByClassName('atc-wrapper');
  [].forEach.call(allAtcWrappers, function (el) {
    el.classList.remove('active');
  });
  targetAtcWrapper.classList.add('active');
};

 })
 ]);